import { render, staticRenderFns } from "./Pagelist.vue?vue&type=template&id=4be3c2b6"
import script from "./Pagelist.vue?vue&type=script&lang=js"
export * from "./Pagelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports